import { homeConstants } from "../constants";

export default function (
  state = {
    data: {},
    isProgress: false,
    status: true,
  },
  action
) {
  switch (action.type) {
    case homeConstants.PRESCRIPTION_API_REQUEST:
      return {
        data: null,
        isProgress: true,
      };
    case homeConstants.PRESCRIPTION_API_SUCCESS:
      return {
        data: action.response.data,
        status: action.response.success,
        isProgress: false,
      };
    case homeConstants.PRESCRIPTION_API_FAILURE:
      return {
        data: null,
        error: action.error,
        isProgress: false,
      };
    default:
      return state;
  }
}
